exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav_menu[data-v-7ba5bd90] {\r\n  margin-bottom: 10px;\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n  background-color: #b3d8fd;\n}\r\n", ""]);

// exports
